'use client'

import { FC } from 'react'

export interface SPVideoInfoOverlayProps {
  title: string
  onShowDetail: () => void
}

const SPVideoInfoOverlay: FC<SPVideoInfoOverlayProps> = ({ title, onShowDetail }) => {
  return (
    <>
      <style>{`
        .sp-video-info-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 26px 8px 12px;
          z-index: 10;
          display: flex;
          justify-content: center;
          color: #fff;
          /* background: linear-gradient(to top, rgba(0,0,0,1.0) 0%, rgba(0,0,0,0) 100%); */
          background: linear-gradient(to top, rgba(26, 26, 26, 1) 0%, rgba(26, 26, 26, 0) 100%);
        }

        .sp-video-info-content {
          width: 95%;
          display: flex;
          /* align-items: flex-end; */
           align-items: center;
          justify-content: space-between;
          gap: 8px;
        }

        .sp-overlay-title {
          font-size: 14px;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          flex: 1;
          min-width: 0;
          margin-right: 4px;
        }

        /* .sp-overlay-subtitle { */
        /*   font-size: 13px; */
        /*   color: rgba(255,255,255,0.9); */
        /*   margin-bottom: 6px; */
        /*   line-height: 1.5; */
        /*   text-shadow: 0 1px 3px rgba(0,0,0,0.5); */
        /* } */

        .sp-overlay-button-row {
          display: flex;
          justify-content: flex-end;
        }

        .sp-overlay-detail-button {
          display: inline-block;
          padding: 4px 15px;
          background: transparent;
          color: white;
          font-size: 13px;
          font-weight: bold;
          border: 1px solid white;
          border-radius: 20px;
          cursor: pointer;
          background: rgba(0, 0, 0, 0.3);
        }
      `}</style>

      <div className="sp-video-info-overlay">
        <div className="sp-video-info-content">
          <div className="sp-overlay-title">{title}</div>
          {/* <div className="sp-overlay-subtitle">{description}</div> */}
          <div className="sp-overlay-button-row">
            <button type="button" className="sp-overlay-detail-button" onClick={onShowDetail}>
              詳しく見る
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default SPVideoInfoOverlay
